import { Complete } from "@/components/common/Complete";
import { createFileRoute } from "@tanstack/react-router";
import { CheckCircle } from "lucide-react";

const efficiencyMessages = [
	"Time saved is time earned!",
	"Efficiency at its finest!",
	"Streamlining patient care, one template at a time!",
	"Making healthcare more efficient!",
	"Time well spent on better patient care!",
	"Automation is the future of healthcare!",
	"Setting up for success!",
	"Smart work pays off!",
	"Efficiency meets excellence!",
	"Time optimization complete!",
] as const;

function getRandomEfficiencyMessage(): string {
	const randomIndex = Math.floor(Math.random() * efficiencyMessages.length);
	return efficiencyMessages[randomIndex] ?? "Time saved is time earned!";
}

export const Route = createFileRoute("/_app/new/diary/complete")({
	component: CompletePage,
});

function CompletePage() {
	const message = getRandomEfficiencyMessage();

	return (
		<Complete
			title="Template Created Successfully!"
			description={message}
			icon={CheckCircle}
			primaryButton={{
				text: "Continue",
				to: "/new/diary",
			}}
		/>
	);
}
